// setupCursor.js
import anime from 'animejs';
import { showScrollToEnter, showSquare } from '../cursorhelper';

/* ────────────────────────────────
 *  util
 * ──────────────────────────────── */
const isCoarse = window.matchMedia('(pointer: coarse)').matches; // phones/tablets

/* ────────────────────────────────
 *  main
 * ──────────────────────────────── */
export default function setupCursor() {
    const cursor       = document.getElementById('cursor');       // wrapper
    const cursorSquare = document.querySelector('.cursor__square');
    const links        = document.querySelectorAll('a');

    /* helpers */
    const enableCursor = () => {
        cursor?.classList.remove('hidden');
        document.body.style.cursor = 'none';
        links.forEach(l => (l.style.cursor = 'none'));

        document.body.addEventListener('pointermove', handlePointerMove);
        links.forEach(l => {
            l.addEventListener('pointerenter', handlePointerEnter);
            l.addEventListener('pointerleave', handlePointerLeave);
        });
    };

    const disableCursor = () => {
        cursor?.classList.add('hidden');
        document.body.style.removeProperty('cursor');
        links.forEach(l => l.style.removeProperty('cursor'));

        document.body.removeEventListener('pointermove', handlePointerMove);
        links.forEach(l => {
            l.removeEventListener('pointerenter', handlePointerEnter);
            l.removeEventListener('pointerleave', handlePointerLeave);
        });
    };

    /* pointer handlers (real mouse only) */
    function handlePointerMove(e) {
        if (e.pointerType !== 'mouse' || !cursor) return;
        const block = cursor.querySelector('.block');
        if (!block) return;

        const { width, height } = block.getBoundingClientRect();
        anime.set(cursor, {
            top:  e.pageY - height / 2,
            left: e.pageX - width  / 2,
        });
    }

    function handlePointerEnter() {
        showSquare();
        anime({ targets: cursorSquare, scale: [1, 0.7], duration: 50, easing: 'linear' });
    }

    function handlePointerLeave() {
        document.body.classList.contains('is-on-homepage-top-section') ? showScrollToEnter() : showSquare();
        anime({ targets: cursorSquare, scale: [0.7, 1], duration: 50, easing: 'linear' });
    }

    /* init */
    if (isCoarse) {
        disableCursor();

        /* hybrid devices: enable once a real mouse appears */
        const detectMouse = e => {
            if (e.pointerType !== 'mouse') return;
            enableCursor();
            document.body.removeEventListener('pointermove', detectMouse);
            document.body.removeEventListener('pointerdown', detectMouse);
        };
        document.body.addEventListener('pointermove', detectMouse, { passive: true });
        document.body.addEventListener('pointerdown', detectMouse, { passive: true });
    } else {
        enableCursor();
    }
}
